import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import MilestoneForm from 'components/organisms/forms/MilestoneForm'

import { crudActionsMap } from 'utils/helpers'

const MilestoneCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('school.academic-calendar')} / ${t('common.' + action)}`} />
      <PageBody>
        <MilestoneForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default MilestoneCrudPage
